import React, { useState } from 'react';
import WelcomeScreen from './components/WelcomeScreen';
import ContactInput from './components/ContactInput';
import PostcodeInput from './components/PostcodeInput';
import HouseTypeInput from './components/HouseTypeInput';
import ElectricitySpendInput from './components/ElectricitySpendInput';
import RoofAreaInput from './components/RoofAreaInput';
import OccupancyInput from './components/OccupancyInput';
import RoofConditionInput from './components/RoofConditionInput';
import OrientationInput from './components/OrientationInput';
import ShadingInput from './components/ShadingInput';
import EVOwnershipInput from './components/EVOwnershipInput';
import CurrentHeatingInput from './components/CurrentHeatingInput';
import OutputScreen from './components/OutputScreen';
import LeadCapture from './components/LeadCapture';
import LoadingScreen from './components/LoadingScreen';


import './App.css';

function App() {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const nextStep = () => {
  setIsLoading(true);
  setTimeout(() => {
    setIsLoading(false);
    setStep((prev) => {
      return prev + 1;
    });
  }, 1000);
};


  const updateFormData = (data) => setFormData({ ...formData, ...data });

  return (
    <div className="app-container">
      {isLoading && <LoadingScreen />}

      {!isLoading && step === 1 && <WelcomeScreen nextStep={nextStep} />}
      {!isLoading && step === 2 && <PostcodeInput nextStep={nextStep} updateFormData={updateFormData} />}
      {!isLoading && step === 3 && <HouseTypeInput nextStep={nextStep} updateFormData={updateFormData} />}
      {!isLoading && step === 4 && (
  <RoofAreaInput
    nextStep={nextStep}
    updateFormData={updateFormData}
    propertyType={formData.houseType} // ✅ This is the key fix
  />
)}

      {!isLoading && step === 5 && <RoofConditionInput nextStep={nextStep} updateFormData={updateFormData} />}
      {!isLoading && step === 6 && <OrientationInput nextStep={nextStep} updateFormData={updateFormData} />}
      {!isLoading && step === 7 && <ShadingInput nextStep={nextStep} updateFormData={updateFormData} />}
      {!isLoading && step === 8 && <OccupancyInput nextStep={nextStep} updateFormData={updateFormData} />}
      {!isLoading && step === 9 && <ElectricitySpendInput nextStep={nextStep} updateFormData={updateFormData} />}
      {!isLoading && step === 10 && <EVOwnershipInput nextStep={nextStep} updateFormData={updateFormData} />}
      {!isLoading && step === 11 && <CurrentHeatingInput nextStep={nextStep} updateFormData={updateFormData} />}
      {!isLoading && step === 12 && (
        <ContactInput
          nextStep={nextStep}
          updateFormData={updateFormData}
          postcode={formData.postcode}
        />
      )}
      {!isLoading && step === 13 && <OutputScreen nextStep={nextStep} formData={formData} />}
      {!isLoading && step === 14 && <LeadCapture formData={formData} />}
    </div>
  );
}

export default App;


